import DeepPartial from '@alltrails/shared/types/modifiers/deepPartial';
import ProfilePhoto from '@alltrails/shared/types/ProfilePhoto';
import type User from '@alltrails/core/types/User';

export const userOne: User = {
  account: {},
  canPurchaseNewSubscription: true,
  canUpgradeExistingSubscription: false,
  id: 1,
  firstName: 'User',
  lastName: 'One',
  slug: 'user-1',
  reputation: 44,
  location: {
    latitude: '38.96407',
    longitude: '-106.98806'
  },
  profilePhoto: {
    id: '1',
    photoHash: 'yyuijhsjh'
  },
  privacyPolicy: {
    content: {
      activities: {
        visibility: 'urn:alltrails:visibility:public'
      },
      completedTrails: {
        visibility: 'urn:alltrails:visibility:public'
      },
      customMaps: {
        visibility: 'urn:alltrails:visibility:public'
      },
      favoriteTrails: {
        visibility: 'urn:alltrails:visibility:public'
      },
      lists: {
        visibility: 'urn:alltrails:visibility:public'
      },
      profile: {
        socialNetwork: {
          visibility: 'urn:alltrails:visibility:public'
        }
      },
      schemaVersion: '1',
      socialNetwork: {
        followRequestsRequired: false
      },
      version: '0'
    }
  },
  permissions: [],
  // incoming props from monolith
  admin: false,
  isPromoEligible: false,
  profile_photo_url: 'https://www.gravatar.com/avatar/yyuijhsjh',
  referral_link: 'https://www.alltrails.com/invite/12345',
  trees_planted: 0,
  marketingLangPreference: 'en',
  created: '2020-04-22T20:00:00.000Z',
  email_none: true,
  subscriptionTier: 'base',
  featureEntitlements: [],
  referralCode: 'xyz123'
};

export const adminUser: User = {
  ...userOne,
  firstName: 'Gorbeaux',
  lastName: 'MacAdmin',
  permissions: ['locations:manage', 'trails:manage', 'users:manage']
};

export function stubbedUserFactory(overrides?: DeepPartial<User>): User {
  const user = { ...userOne };
  return {
    ...user,
    ...overrides,
    account: { ...user.account, ...overrides?.account },
    location: { ...user.location, ...overrides?.location },
    profilePhoto: { ...user.profilePhoto, ...overrides?.profilePhoto } as ProfilePhoto,
    subscription: { ...user.subscription, ...overrides?.subscription } as User['subscription']
  } as User;
}
